import { render, staticRenderFns } from "./MicroscopyForm.vue?vue&type=template&id=1dad4886"
import script from "./MicroscopyForm.vue?vue&type=script&lang=js"
export * from "./MicroscopyForm.vue?vue&type=script&lang=js"
import style0 from "./MicroscopyForm.vue?vue&type=style&index=0&id=1dad4886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports